import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import ProviderManager from '../../../provider/providerManager';
import { showAppLoader, hideAppLoader } from '../../Shared/Loader/LoaderSlice';
export const BenefitCustomerStep = {
  SelectBenefit : 'SelectBenefit',
  Success : 'Success',
  Failed : 'Failed',
}


export const createWorkOrder = createAsyncThunk('BenefitCustomerBlockSlice/createWorkOrder', async (data, thunkAPI) => {
  try {
    thunkAPI.dispatch(showAppLoader());
    const result = await ProviderManager.getProviderData('createWorkOrder', data);

    thunkAPI.dispatch(hideAppLoader());
    return result.Body.isSuccess
  } catch (error) {
    thunkAPI.dispatch(hideAppLoader());
    return false;
  }
});

const BenefitCustomerBlockSlice = createSlice({
  name: 'BenefitCustomerBlockSlice',
  initialState: {
   currentStep: BenefitCustomerStep.SelectBenefit,
  },
  reducers: {
    resetState: (state, action) => {
      state.currentStep = BenefitCustomerStep.SelectBenefit;
    },
  },
  extraReducers: {
    [createWorkOrder.fulfilled]: (state, action) => {
      if(action.payload){
        state.currentStep = BenefitCustomerStep.Success;
      }
      else{
        state.currentStep = BenefitCustomerStep.Failed;
      }
    },
  },
});

export const {resetState} = BenefitCustomerBlockSlice.actions;

export default BenefitCustomerBlockSlice.reducer;
